import { axiosInstance } from "contexts/axiosApiInstance";

export type InvitationResource = "model" | "table";

// Single endpoint for resending a pending registration email across
// model / table shares. Resource-specific permission, link, and
// email body are resolved server-side from the discriminated `target`.
export const resendInvitation = async (
  resource: InvitationResource,
  resourceId: string,
  resourceName: string,
  email: string,
  inviterName: string,
): Promise<void> => {
  await axiosInstance.post("/action/resend_invitation", {
    email,
    inviter_name: inviterName,
    resource_name: resourceName,
    target: { type: resource, id: resourceId },
  });
};
